export enum TestType {  
  Minimum = 'Minimum',
  Maximum = 'Maximum',
  InclusiveRange = 'InclusiveRange',
  ExclusiveRange = 'ExclusiveRange',  
  Logical = 'Logical',
  Equals = 'Equals'
}
